module.exports = __webpack_public_path__ + "static/img/xiaotian5.9a0a798.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/homePortal/xiaotian5.png
// module id = NHfk
// module chunks = 1